module.exports = __webpack_public_path__ + "static/media/sf-test-10.5b0bd8f8.mp3";